
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spare-parts",
      function () {
        return require("private-next-pages/spare-parts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spare-parts"])
      });
    }
  